// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import {
    Divider,
    Fab,
    FormControlLabel,
    Checkbox,
    Autocomplete
} from '@mui/material'

import { useNavigate, useParams } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../../components/icon';
import apiUrl from '../../../../configs/constant';

export default function Add() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token

    const cabang = JSON.parse(localStorage.getItem('cabang')!)

    const { id } = useParams();

    // ** State
    const [valDoctag, setValDoctag] = useState<any>(null)
    const [listDoctag, setListDoctag] = useState<any[]>([])

    useEffect(() => {
        getData()
    }, [])

    const navigate = useNavigate();


    const getData = () => {
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const url = apiUrl.apiUrl + '/mm/jenis-barang/detail/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setValue('jenis_barang', data.jenis_barang)
                    setValue('is_kain', data.is_kain)
                    setValue('is_jasa', data.is_jasa)
                    setValue('keterangan', data.keterangan)
                    setValue('keterangan_pembelian', data.keterangan_pembelian)
                    setValue('lebar', data.lebar)
                    setValue('mmbarang_sysdoctag_id', data.mmbarang_sysdoctag_id)
                    setValue('sku', data.sku)

                    getDoctagBarang(data.mmbarang_sysdoctag_id)
                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getDoctagBarang = (ids: any) => {
        const url = apiUrl.apiUrl + '/system/doctag/list-combo'
        axios
            .get(url, {
                params: {
                    syscabang_id: cabang,
                    sysmenu_id: 17
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    data.forEach((element: any) => {
                        if (element.id == ids) {
                            setValDoctag(element)
                        }
                    });
                    setListDoctag(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }


    const handleChangeAutocompleteDoctag = (event: SyntheticEvent, newValue: any | null) => {
        setValue('mmbarang_sysdoctag_id', newValue?.id)
        setValDoctag(newValue)
    }


    interface FormInputs {
        keterangan: any,
        sku: any,
        jenis_barang: any,
        mmbarang_sysdoctag_id: any,
        keterangan_pembelian: any,
        lebar: any,
        is_kain: any,
        is_jasa: any
    }

    const defaultValues = {
        keterangan: '',
        is_kain: 0,
        is_jasa: 0,
        sku: '',
        jenis_barang: '',
        mmbarang_sysdoctag_id: ''
    }

    const {
        control,
        handleSubmit,
        setValue,
        watch,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const onSubmit = (data: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin menyimpan data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Simpan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/mm/jenis-barang/edit/' + id
                axios
                    .post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    navigate('/mm/jenis-barang')
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Detail Master Jenis Barang
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center' }}>
                        No. Dokumen : <b>{id}</b>
                    </Typography>
                    <Divider sx={{ mb: 3 }} />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='mmbarang_sysdoctag_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valDoctag}
                                                options={listDoctag}
                                                id='mmbarang_sysdoctag_id'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteDoctag}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Dokumen Barang'
                                                        error={Boolean(errors.mmbarang_sysdoctag_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.mmbarang_sysdoctag_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='sku'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='SKU'
                                                error={Boolean(errors.sku)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.sku && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='jenis_barang'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Jenis Barang'
                                                error={Boolean(errors.jenis_barang)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.jenis_barang && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 2,
                                        height: '56px' // Match TextField height
                                    }}
                                >
                                    <FormControl>
                                        <Controller
                                            name='is_kain'
                                            control={control}
                                            rules={{ required: true }}
                                            render={({ field: { value, onChange } }) => (
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={Boolean(value)}
                                                            onChange={e => {
                                                                const isChecked = e.target.checked;
                                                                onChange(isChecked ? 1 : 0);
                                                            }}
                                                            sx={errors.is_kain ? { color: 'error.main' } : null}
                                                        />
                                                    }
                                                    label='Kain?'
                                                />
                                            )}
                                        />
                                    </FormControl>
                                    <FormControl>
                                        <Controller
                                            name='is_jasa'
                                            control={control}
                                            rules={{ required: true }}
                                            render={({ field: { value, onChange } }) => (
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={Boolean(value)}
                                                            onChange={e => {
                                                                const isChecked = e.target.checked;
                                                                onChange(isChecked ? 1 : 0);
                                                            }}
                                                            sx={errors.is_jasa ? { color: 'error.main' } : null}
                                                        />
                                                    }
                                                    label='Jasa?'
                                                />
                                            )}
                                        />
                                    </FormControl>
                                </Box>
                                {(errors.is_kain || errors.is_jasa) && (
                                    <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                )}
                            </Grid>
                            {
                                watch('is_kain') == 1 ?
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth>
                                        <Controller
                                            name='lebar'
                                            control={control}
                                            rules={{ required: true }}
                                            render={({ field: { value, onChange } }) => (
                                                <TextField
                                                    label='Lebar'
                                                    error={Boolean(errors.lebar)}
                                                    onChange={onChange}
                                                    value={value}
                                                    type='number'
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            )}
                                        />
                                        {errors.lebar && (
                                            <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>
                                :null
                            }
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Keterangan'
                                                multiline
                                                rows={2}
                                                error={Boolean(errors.keterangan)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.keterangan && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan_pembelian'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Keterangan Pembelian'
                                                multiline
                                                rows={2}
                                                error={Boolean(errors.keterangan_pembelian)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.keterangan_pembelian && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box
                                    sx={{
                                        width: '100%',
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mt: 4 }}>
                                        <Button variant='contained' type='submit'
                                        >
                                            SIMPAN
                                        </Button>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </Grid>
        </Grid>
    )
}
